<template>
	<div class="d-inline-flex align-center justify-center" ref="elem">
		<v-btn @click="up" x-small fab color="#eee" elevation="0"><v-icon color="blue">mdi-plus</v-icon></v-btn>
		<span v-show="!manual" @click="manual = true" class="mx-2" :class="[localSize, localColor]">{{ isPrice ? String(localValue).toPriceFormat() : localValue }} {{ append || '' }}</span>
		<v-text-money style="max-width: 50%;font-size: 26px; color: purple;min-height: 65px;" v-if="manual" v-model="localValue" dense outlined class="center-input mx-2" @blur="test" />
		<v-btn @click="down" x-small fab color="#eee" elevation="0"><v-icon color="blue">mdi-minus</v-icon></v-btn>
	</div>
</template>

<script>
	export default {
		name: 'ValueStepper',
		props: {
			size: {
				type: String,
				default: 'h6',
			},
			color: {
				type: String,
				default: 'grey'
			},
			value: {
				type: [Number, String],
				default: 0
			},
			step: {
				type: Number,
				default: 1
			},
			max: {
				type: Number,
				default: 0
			},
			min: {
				type: Number,
				default: 0
			},
			isPrice: {
				type: Boolean
			},
			defaultManual: {
				type: Boolean
			},
			append: {
				type: String
			}
		},
		data: () => ({
			localValue: '',
			manual: false
		}),
		mounted() {
			this.localValue = this.value
			this.manual = this.defaultManual
		},
		computed: {
			localSize() {
				return `text-${this.size}`
			},
			localColor() {
				return `${this.color}--text`
			}
		},
		watch: {
			localValue: {
				handler(val, oldVal) {
					if (val != oldVal) {
						if (this.max != 0 && Number(this.localValue) > this.max)
							this.localValue = this.max
						if (this.min != 0 && Number(this.localValue) < this.min)
							this.localValue = this.min
						this.$emit('input', this.localValue)
					}
				}
			},
			value: {
				handler(val, oldVal) {
					this.localValue = val
				}
			},
			max: {
				handler(val, oldVal) {
					if (val && this.localValue > val)
						this.localValue = val
				}
			},
			min: {
				handler(val, oldVal) {
					if (val && this.localValue < val)
						this.localValue = val
				}
			}
		},
		methods: {
			up() {
				if (this.max != 0 && Number(this.localValue) + Number(this.step) > this.max)
					this.localValue = this.max
				else
					this.localValue = Number(this.localValue) + Number(this.step)
			},
			down() {
				if (Number(this.localValue) - this.step < this.min)
					this.localValue = this.min
				else
					this.localValue -= Number(this.step)
			},
			test() {
				this.manual = false
			}
		}
	}
</script>

<style scoped>
	.timer {
		font-size: 1rem;
		font-weight: bold;
		color: #000;
	}
</style>